function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.75 10.123c-.462-.46-.692-.691-.857-.96a2.667 2.667 0 01-.32-.771C1.5 8.085 1.5 7.759 1.5 7.106v-1.34c0-1.493 0-2.24.29-2.81.256-.502.664-.91 1.166-1.165.57-.291 1.317-.291 2.81-.291h1.34c.653 0 .979 0 1.286.074.272.065.532.173.77.319.27.165.5.395.961.857l2.23 2.23c1.241 1.24 1.861 1.86 2.113 2.568a3.333 3.333 0 010 2.237c-.252.708-.872 1.328-2.112 2.569-1.241 1.24-1.861 1.86-2.569 2.112a3.333 3.333 0 01-2.237 0c-.707-.252-1.328-.872-2.568-2.112l-2.23-2.23zM6.667 8a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667z",
  fill: "#0063E3"
});

var SvgLabelFilled = function SvgLabelFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default SvgLabelFilled;